export default "__VITE_ASSET__w2iN3Zx7__"